export default function useSnakeToCamelCase() {
    return (stringToConvert) =>
        stringToConvert
            ? stringToConvert.replace(/(_\w)/g, (k) => k[1].toUpperCase())
            : stringToConvert;
}
